import { Component } from '@resn/gozer-core/component';
class RendererBatch extends Component {
    static instance;

    options = {};

    props = {};

    async onSetup() {
        this.batch = this.options.batch || [];
        RendererBatch.instance = this;
    }

    static getInstance() {
        return RendererBatch.instance;
    }

    getAvailableRenderer() {
        const renderer = this.batch.filter((renderer) => !renderer.props.active)[0];
        if (renderer) return renderer;
        else console.warn('no renderer available');
    }

    add(renderer) {
        this.batch.push(renderer);
    }
}
export default RendererBatch;
